import { DashboardStats, Transaction, ApiKey } from '@ppp/types';

// State & API Configuration
const DEFAULT_WORKER_URL = 'https://ppp-test-worker.theasmat.workers.dev';
let currentApiBase = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ? ''
  : (localStorage.getItem('ppp_api_url') || DEFAULT_WORKER_URL);

let currentPasskey = localStorage.getItem('phonepe_passkey') || 'test-user-passkey-123';
let currentPage = 1;
let currentSearch = '';
let autoRefreshTimer: any = null;
let watcherTimer: any = null;

// Tab Switching Elements
const tabBtns = document.querySelectorAll('.tab-btn');
const tabContents = document.querySelectorAll('.tab-content');

tabBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    tabBtns.forEach((b) => b.classList.remove('active'));
    tabContents.forEach((c) => c.classList.remove('active'));

    btn.classList.add('active');
    const tabName = btn.getAttribute('data-tab');
    const target = document.getElementById(`tab-${tabName}`);
    if (target) target.classList.add('active');
  });
});

// DOM Elements: Header & Status
const sessionIndicator = document.getElementById('sessionIndicator') as HTMLDivElement;
const sessionStatusText = document.getElementById('sessionStatusText') as HTMLSpanElement;
const authBtn = document.getElementById('authBtn') as HTMLButtonElement;
const authModal = document.getElementById('authModal') as HTMLDivElement;
const passkeyInput = document.getElementById('passkeyInput') as HTMLInputElement;
const apiUrlInput = document.getElementById('apiUrlInput') as HTMLInputElement;
const savePasskeyBtn = document.getElementById('savePasskeyBtn') as HTMLButtonElement;
const toastEl = document.getElementById('toast') as HTMLDivElement;

// DOM Elements: Stats
const todayAmountEl = document.getElementById('todayAmount') as HTMLDivElement;
const todayCountEl = document.getElementById('todayCount') as HTMLSpanElement;
const totalAmountEl = document.getElementById('totalAmount') as HTMLDivElement;
const totalCountEl = document.getElementById('totalCount') as HTMLSpanElement;
const lastSyncAgoEl = document.getElementById('lastSyncAgo') as HTMLDivElement;

// DOM Elements: Feed Controls
const searchInput = document.getElementById('searchInput') as HTMLInputElement;
const autoRefreshToggle = document.getElementById('autoRefreshToggle') as HTMLInputElement;
const refreshBtn = document.getElementById('refreshBtn') as HTMLButtonElement;
const pollBtn = document.getElementById('pollBtn') as HTMLButtonElement;
const reconcileBtn = document.getElementById('reconcileBtn') as HTMLButtonElement;

// DOM Elements: Tables & Cards
const txTableBody = document.getElementById('txTableBody') as HTMLTableSectionElement;
const txCardsList = document.getElementById('txCardsList') as HTMLDivElement;
const paginationInfo = document.getElementById('paginationInfo') as HTMLSpanElement;
const pageIndicator = document.getElementById('pageIndicator') as HTMLSpanElement;
const prevPageBtn = document.getElementById('prevPageBtn') as HTMLButtonElement;
const nextPageBtn = document.getElementById('nextPageBtn') as HTMLButtonElement;

// DOM Elements: Test Payment Console (One At A Time)
const modePayBtn = document.getElementById('modePayBtn') as HTMLButtonElement;
const modeQrBtn = document.getElementById('modeQrBtn') as HTMLButtonElement;
const payView = document.getElementById('payView') as HTMLDivElement;
const qrView = document.getElementById('qrView') as HTMLDivElement;

const testAmountInput = document.getElementById('testAmountInput') as HTMLInputElement;
const presetChips = document.querySelectorAll<HTMLButtonElement>('.preset-chip');
const summaryOrderRef = document.getElementById('summaryOrderRef') as HTMLSpanElement;
const testVpaInput = document.getElementById('testVpaInput') as HTMLInputElement;
const testRefInput = document.getElementById('testRefInput') as HTMLInputElement;
const testNoteInput = document.getElementById('testNoteInput') as HTMLInputElement;

const payDirectBtn = document.getElementById('payDirectBtn') as HTMLButtonElement;
const payBtnLabel = document.getElementById('payBtnLabel') as HTMLSpanElement;
const copyUpiLinkBtn = document.getElementById('copyUpiLinkBtn') as HTMLButtonElement;
const testQrImage = document.getElementById('testQrImage') as HTMLImageElement;
const radarText = document.getElementById('radarText') as HTMLSpanElement;

// DOM Elements: UTR Lookup
const lookupForm = document.getElementById('lookupForm') as HTMLFormElement;
const lookupInput = document.getElementById('lookupInput') as HTMLInputElement;
const lookupSubmitBtn = document.getElementById('lookupSubmitBtn') as HTMLButtonElement;
const lookupResultBox = document.getElementById('lookupResultBox') as HTMLDivElement;

// Initialize default test reference
function initOrderRef() {
  const randNum = Math.floor(100000 + Math.random() * 900000);
  const ref = `TEST-${randNum}`;
  if (testRefInput) testRefInput.value = ref;
  if (summaryOrderRef) summaryOrderRef.textContent = ref;
}
initOrderRef();

// Toast Helper
function showToast(message: string, isError = false) {
  toastEl.textContent = message;
  toastEl.style.borderColor = isError ? 'var(--color-danger)' : 'var(--border-subtle)';
  toastEl.classList.remove('hidden');
  setTimeout(() => {
    toastEl.classList.add('hidden');
  }, 3500);
}

// Auth & Session Modal Elements
const closeAuthModalBtn = document.getElementById('closeAuthModalBtn') as HTMLButtonElement;
const subtabCookieBtn = document.getElementById('subtabCookieBtn') as HTMLButtonElement;
const subtabBookmarkletBtn = document.getElementById('subtabBookmarkletBtn') as HTMLButtonElement;
const subtabSettingsBtn = document.getElementById('subtabSettingsBtn') as HTMLButtonElement;
const authPaneCookie = document.getElementById('authPaneCookie') as HTMLDivElement;
const authPaneBookmarklet = document.getElementById('authPaneBookmarklet') as HTMLDivElement;
const authPaneSettings = document.getElementById('authPaneSettings') as HTMLDivElement;

const pastedCookieInput = document.getElementById('pastedCookieInput') as HTMLTextAreaElement;
const connectCookieBtn = document.getElementById('connectCookieBtn') as HTMLButtonElement;
const generateTicketBtn = document.getElementById('generateTicketBtn') as HTMLButtonElement;
const bookmarkletReadyBox = document.getElementById('bookmarkletReadyBox') as HTMLDivElement;
const bookmarkletAnchor = document.getElementById('bookmarkletAnchor') as HTMLAnchorElement;
const testUserToggle = document.getElementById('testUserToggle') as HTMLInputElement;

let isTestMode = localStorage.getItem('ppp_test_mode') === 'true';
if (testUserToggle) {
  testUserToggle.checked = isTestMode;
  testUserToggle.addEventListener('change', () => {
    isTestMode = testUserToggle.checked;
    localStorage.setItem('ppp_test_mode', String(isTestMode));
    showToast(isTestMode ? '🧪 Switched to Test Mode (Real user sandbox)' : '🟢 Switched to Live Merchant Mode');
  });
}

function switchAuthSubtab(tab: 'cookie' | 'bookmarklet' | 'settings') {
  if (subtabCookieBtn) subtabCookieBtn.style.borderBottomColor = tab === 'cookie' ? 'var(--color-primary)' : 'transparent';
  if (subtabBookmarkletBtn) subtabBookmarkletBtn.style.borderBottomColor = tab === 'bookmarklet' ? 'var(--color-primary)' : 'transparent';
  if (subtabSettingsBtn) subtabSettingsBtn.style.borderBottomColor = tab === 'settings' ? 'var(--color-primary)' : 'transparent';

  if (authPaneCookie) authPaneCookie.classList.toggle('hidden', tab !== 'cookie');
  if (authPaneBookmarklet) authPaneBookmarklet.classList.toggle('hidden', tab !== 'bookmarklet');
  if (authPaneSettings) authPaneSettings.classList.toggle('hidden', tab !== 'settings');
}

if (subtabCookieBtn) subtabCookieBtn.addEventListener('click', () => switchAuthSubtab('cookie'));
if (subtabBookmarkletBtn) subtabBookmarkletBtn.addEventListener('click', () => switchAuthSubtab('bookmarklet'));
if (subtabSettingsBtn) subtabSettingsBtn.addEventListener('click', () => switchAuthSubtab('settings'));

function showAuthModal() {
  passkeyInput.value = currentPasskey;
  if (apiUrlInput) apiUrlInput.value = currentApiBase;
  authModal.classList.remove('hidden');
}

function hideAuthModal() {
  authModal.classList.add('hidden');
}

if (closeAuthModalBtn) closeAuthModalBtn.addEventListener('click', hideAuthModal);
authBtn.addEventListener('click', showAuthModal);

// 1. Cookie Paste Handler
if (connectCookieBtn) {
  connectCookieBtn.addEventListener('click', async () => {
    const rawCookie = (pastedCookieInput?.value || '').trim();
    if (!rawCookie) {
      showToast('Please paste your PhonePe cookie string or token', true);
      return;
    }

    connectCookieBtn.disabled = true;
    showToast('Connecting & verifying PhonePe session in SQLite D1...');

    const res = await apiRequest<{ success: boolean; message: string; merchantId?: string; sessionValid?: boolean; error?: string }>(
      '/api/session/sync',
      {
        method: 'POST',
        body: JSON.stringify({ cookie: rawCookie })
      }
    );

    connectCookieBtn.disabled = false;

    if (res?.success) {
      showToast('🎉 PhonePe session paired and verified in D1!');
      pastedCookieInput.value = '';
      hideAuthModal();
      refreshAll();
    } else {
      showToast(`Connection failed: ${res?.message || res?.error || 'Invalid session credentials'}`, true);
    }
  });
}

// 2. Secure Bookmarklet Handler (Generates 15-Minute Signed Ticket)
if (generateTicketBtn) {
  generateTicketBtn.addEventListener('click', async () => {
    generateTicketBtn.disabled = true;
    showToast('Generating 15-minute signed pairing ticket...');

    const res = await apiRequest<{ success: boolean; ticket: string; expiresAt: number; error?: string }>('/api/session/ticket');
    generateTicketBtn.disabled = false;

    if (res?.success && res.ticket) {
      const ticket = res.ticket;
      const workerUrl = currentApiBase || window.location.origin;

      // Minified, safe bookmarklet payload
      const scriptCode = `javascript:(function(){const h=window.location.hostname;if(!h.includes('phonepe.com')){alert('⚠️ Please open business.phonepe.com and log in before clicking this bookmarklet.');return;}const c=document.cookie;const t=localStorage.getItem('token')||sessionStorage.getItem('token')||'';if(!c&&!t){alert('⚠️ No active PhonePe session detected. Please log into your merchant account first.');return;}fetch('${workerUrl}/api/session/sync?ticket=${encodeURIComponent(ticket)}',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({cookie:c,token:t})}).then(r=>r.json()).then(d=>{if(d.success)alert('🎉 PhonePe Gateway Paired Successfully! You can close this tab.');else alert('❌ Pairing failed: '+(d.error||d.message||'Unknown error'));}).catch(e=>alert('❌ Network error: '+e.message));})();`;

      if (bookmarkletAnchor) {
        bookmarkletAnchor.href = scriptCode;
      }
      if (bookmarkletReadyBox) {
        bookmarkletReadyBox.classList.remove('hidden');
      }
      showToast('Signed bookmarklet generated! Drag it to your bookmarks bar.');
    } else {
      showToast(`Ticket generation failed: ${res?.error || 'Authentication error'}`, true);
    }
  });
}

savePasskeyBtn.addEventListener('click', () => {
  const val = passkeyInput.value.trim();
  currentPasskey = val;
  localStorage.setItem('phonepe_passkey', val);

  if (apiUrlInput) {
    const urlVal = apiUrlInput.value.trim().replace(/\/+$/, '');
    currentApiBase = urlVal;
    localStorage.setItem('ppp_api_url', urlVal);
  }

  hideAuthModal();
  showToast('Settings saved! Reconnecting...');
  refreshAll();
});

// Clipboard Helper
(window as any).copyToClipboard = (text: string, label: string) => {
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    showToast(`Copied ${label}!`);
  }).catch(() => {
    showToast('Failed to copy', true);
  });
};

// Generic API Client
async function apiRequest<T = any>(path: string, options: RequestInit = {}): Promise<T | null> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as any)
  };

  if (currentPasskey) {
    headers['X-Access-Token'] = currentPasskey;
    headers['Authorization'] = `Bearer ${currentPasskey}`;
  }

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const targetUrl = path.startsWith('http') ? path : `${currentApiBase}${cleanPath}`;

  try {
    const res = await fetch(targetUrl, { ...options, headers });
    if (res.status === 401) {
      showToast('Authentication required (Invalid Passkey)', true);
      showAuthModal();
      return null;
    }
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || `Request failed (${res.status})`);
    }
    return await res.json();
  } catch (err: any) {
    console.error('API Error:', err);
    showToast(err.message || 'Network request failed', true);
    return null;
  }
}

// Formatters
function formatINR(val: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2
  }).format(val);
}

function formatTimeIST(ts: number): string {
  if (!ts) return '--';
  return new Date(ts).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function formatRelativeTime(ts: number): string {
  if (!ts) return '--';
  const diffSec = Math.floor((Date.now() - ts) / 1000);
  if (diffSec < 10) return 'Just now';
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  return `${diffHr}h ago`;
}

// -------------------------------------------------------------
// Load Stats
// -------------------------------------------------------------
async function loadStats() {
  const data = await apiRequest<{ success: boolean; stats: DashboardStats }>('/api/transactions/stats');
  if (!data || !data.stats) return;

  const { stats } = data;
  todayAmountEl.textContent = formatINR(stats.todayAmount || 0);
  todayCountEl.textContent = String(stats.todayCount || 0);
  totalAmountEl.textContent = formatINR(stats.totalAmount || 0);
  totalCountEl.textContent = String(stats.totalCount || 0);

  if (stats.lastSyncTimestamp) {
    lastSyncAgoEl.textContent = formatRelativeTime(stats.lastSyncTimestamp);
  } else {
    lastSyncAgoEl.textContent = 'None';
  }

  sessionIndicator.className = 'status-pill ' + (stats.isSessionActive ? 'status-active' : 'status-inactive');
  sessionStatusText.textContent = stats.isSessionActive ? 'Active' : 'Offline';
}

// -------------------------------------------------------------
// Load Transactions (Desktop Table + Mobile Cards)
// -------------------------------------------------------------
async function loadTransactions() {
  const query = new URLSearchParams({
    page: String(currentPage),
    limit: '25'
  });
  if (currentSearch) {
    query.set('search', currentSearch);
  }

  const data = await apiRequest<{
    success: boolean;
    total: number;
    totalAmount?: number;
    page: number;
    totalPages: number;
    transactions: Transaction[];
  }>(`/api/transactions/success?${query.toString()}`);

  if (!data) return;

  const { transactions, total, page, totalPages } = data;

  if (transactions.length === 0) {
    const emptyMsg = currentSearch ? 'No matching completed transactions.' : 'No successful transactions recorded yet in Cloudflare D1.';
    txTableBody.innerHTML = `<tr><td colspan="8" class="table-placeholder">${emptyMsg}</td></tr>`;
    txCardsList.innerHTML = `<div class="table-placeholder">${emptyMsg}</div>`;
    paginationInfo.textContent = 'Showing 0 of 0';
    pageIndicator.textContent = 'Page 1';
    prevPageBtn.disabled = true;
    nextPageBtn.disabled = true;
    return;
  }

  // 1. Render Desktop Table (Success Only)
  txTableBody.innerHTML = transactions.map((t) => {
    const isSettled = t.settlementStatus === 'SETTLED';
    const settlementBadge = `<span class="badge ${isSettled ? 'badge-settled' : 'badge-pending'}">${t.settlementStatus || 'PENDING'}</span>`;
    const appBadge = `<span class="badge badge-app">${t.paymentApp || 'UPI'}</span>`;
    const orderRef = t.merchantTransactionId ? `<span style="font-size:11px; color:#a5b4fc; font-weight:600; display:block;">Ref: ${t.merchantTransactionId}</span>` : '';
    const safeNote = (t.transactionNote || '').replace(/'/g, "\\'");

    return `
      <tr>
        <td>
          <div style="font-weight:600;">${formatTimeIST(t.transactionDate)}</div>
          <div style="font-size:11px; color:var(--text-dim);">${formatRelativeTime(t.transactionDate)}</div>
        </td>
        <td>
          <span class="amount-badge">₹${Number(t.amount).toFixed(2)}</span>
        </td>
        <td>
          <div style="display:flex; flex-direction:column; gap:2px;">
            <span style="font-weight:600;">${t.payerName || 'Anonymous Customer'}</span>
            <span style="font-family:var(--font-mono); font-size:11px; color:var(--text-muted);">${t.payerVpa || 'UPI Payer'}</span>
            ${t.transactionNote ? `<span style="font-size:11px; color:var(--text-dim); font-style:italic;">"${t.transactionNote}"</span>` : ''}
          </div>
        </td>
        <td>
          <div class="utr-pill" onclick="copyToClipboard('${t.utr || t.transactionId || ''}', 'UTR')" title="Tap to copy UTR">
            <span>${t.utr || t.transactionId || 'N/A'}</span>
          </div>
          ${orderRef}
        </td>
        <td>
          <div style="display:flex; flex-direction:column; font-size:12px;">
            <span style="font-weight:600;">${t.storeName || 'Store'}</span>
            <span style="font-size:11px; color:var(--text-dim);">${t.terminalName || 'Terminal'}</span>
          </div>
        </td>
        <td>${appBadge}</td>
        <td>
          <span class="badge badge-settled">COMPLETED</span>
          ${settlementBadge}
        </td>
        <td>
          <button type="button" class="btn btn-secondary btn-sm" style="padding:4px 8px; font-size:11px;" onclick="openOrderModal('${t.utr || t.unitId}', '${t.merchantTransactionId || ''}', '${safeNote}')" title="Edit Custom Order ID">
            ✏️ Ref
          </button>
        </td>
      </tr>
    `;
  }).join('');

  // 2. Render Mobile Cards (Success Only)
  txCardsList.innerHTML = transactions.map((t) => {
    const isSettled = t.settlementStatus === 'SETTLED';
    const settlementBadge = `<span class="badge ${isSettled ? 'badge-settled' : 'badge-pending'}">${t.settlementStatus || 'PENDING'}</span>`;
    const appBadge = `<span class="badge badge-app">${t.paymentApp || 'UPI'}</span>`;
    const safeNote = (t.transactionNote || '').replace(/'/g, "\\'");

    return `
      <div class="mobile-card">
        <div class="mobile-card-top">
          <span class="amount-badge">₹${Number(t.amount).toFixed(2)}</span>
          <div style="display:flex; gap:6px; align-items:center;">
            ${appBadge}
            <span class="badge badge-settled">COMPLETED</span>
            ${settlementBadge}
          </div>
        </div>

        <div class="mobile-card-customer">
          <span class="customer-name">${t.payerName || 'Anonymous Customer'}</span>
          <span class="customer-vpa">${t.payerVpa || 'UPI Payer'}</span>
          ${t.merchantTransactionId ? `<span style="font-size:11px; color:#a5b4fc; font-weight:600;">Order ID: ${t.merchantTransactionId}</span>` : ''}
          ${t.transactionNote ? `<span style="font-size:11px; color:var(--text-dim); font-style:italic;">Note: "${t.transactionNote}"</span>` : ''}
        </div>

        <div class="mobile-card-footer">
          <div style="display:flex; gap:6px; align-items:center;">
            <div class="utr-pill" onclick="copyToClipboard('${t.utr || t.transactionId || ''}', 'UTR')">
              <span>UTR: ${t.utr || t.transactionId || 'N/A'}</span>
            </div>
            <button type="button" class="btn btn-secondary btn-sm" style="padding:2px 8px; font-size:11px;" onclick="openOrderModal('${t.utr || t.unitId}', '${t.merchantTransactionId || ''}', '${safeNote}')">
              ✏️ Ref
            </button>
          </div>
          <div style="text-align:right;">
            <div>${formatRelativeTime(t.transactionDate)}</div>
            <div style="font-size:10px; color:var(--text-dim);">${t.terminalName || 'Terminal'}</div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  const startIdx = (page - 1) * 25 + 1;
  const endIdx = Math.min(total, page * 25);
  paginationInfo.textContent = `Showing ${startIdx}-${endIdx} of ${total} success payments`;
  pageIndicator.textContent = `Page ${page} of ${Math.max(1, totalPages)}`;
  prevPageBtn.disabled = page <= 1;
  nextPageBtn.disabled = page >= totalPages;
}

function refreshAll() {
  loadStats();
  loadTransactions();
  loadUpiList();
  loadApiKeys();
  loadWebhookSettings();
  loadWebhookDeliveries();
}

// Search debouncing
let searchDebounce: any = null;
searchInput.addEventListener('input', () => {
  clearTimeout(searchDebounce);
  searchDebounce = setTimeout(() => {
    currentSearch = searchInput.value.trim();
    currentPage = 1;
    loadTransactions();
  }, 300);
});

// Pagination
prevPageBtn.addEventListener('click', () => {
  if (currentPage > 1) {
    currentPage--;
    loadTransactions();
  }
});

nextPageBtn.addEventListener('click', () => {
  currentPage++;
  loadTransactions();
});

// Manual poll & reconcile
pollBtn.addEventListener('click', async () => {
  pollBtn.disabled = true;
  showToast('Polling PPP live stream...');
  const res = await apiRequest<{ success: boolean; newCount: number; error?: string }>('/api/poll/manual', {
    method: 'POST'
  });
  pollBtn.disabled = false;
  if (res?.success) {
    showToast(`Live poll done: ${res.newCount} new payment(s)!`);
    refreshAll();
  } else {
    showToast(`Poll failed: ${res?.error || 'Unknown'}`, true);
  }
});

reconcileBtn.addEventListener('click', async () => {
  reconcileBtn.disabled = true;
  showToast('Running reconciliation catchup...');
  const res = await apiRequest<{ success: boolean; processedCount: number; newCount: number; updatedCount: number; error?: string }>(
    '/api/reconcile/run',
    {
      method: 'POST',
      body: JSON.stringify({ lookbackHours: 24 })
    }
  );
  reconcileBtn.disabled = false;
  if (res?.success) {
    showToast(`Reconciled: ${res.processedCount} processed!`);
    refreshAll();
  } else {
    showToast(`Reconciliation failed: ${res?.error || 'Unknown'}`, true);
  }
});

refreshBtn.addEventListener('click', refreshAll);

// Auto-refresh
function setupAutoRefresh() {
  if (autoRefreshTimer) clearInterval(autoRefreshTimer);
  if (autoRefreshToggle.checked) {
    autoRefreshTimer = setInterval(() => {
      refreshAll();
    }, 10000);
  }
}
autoRefreshToggle.addEventListener('change', setupAutoRefresh);

// -------------------------------------------------------------
// Test Payment Console Logic (One At A Time & Direct UPI Deeplink)
// -------------------------------------------------------------
let currentCheckoutMode: 'pay' | 'qr' = 'pay';

// Prefill saved VPA if any
const savedVpa = localStorage.getItem('phonepe_test_vpa');
if (savedVpa && testVpaInput) {
  testVpaInput.value = savedVpa;
}

function updatePayAmountDisplay(amountNum: number) {
  if (payBtnLabel) {
    payBtnLabel.textContent = `Pay ₹${amountNum.toFixed(2)} via UPI`;
  }
}

function getUpiDetails(): { url: string; amt: number; ref: string } {
  const amt = parseFloat(testAmountInput.value) || 1.0;
  const vpa = testVpaInput.value.trim() || 'phonepe.business@ybl';
  const ref = testRefInput.value.trim() || `TEST-${Date.now()}`;
  const note = testNoteInput.value.trim() || 'Sentinel Test';

  if (vpa) {
    localStorage.setItem('phonepe_test_vpa', vpa);
  }

  const params = `pa=${encodeURIComponent(vpa)}&pn=PPP&am=${amt.toFixed(2)}&tr=${encodeURIComponent(ref)}&tn=${encodeURIComponent(note)}&cu=INR`;
  return {
    url: `upi://pay?${params}`,
    amt,
    ref
  };
}

function updateQrCode() {
  const { url, amt, ref } = getUpiDetails();
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(url)}`;
  if (testQrImage && testQrImage.src !== qrUrl) {
    testQrImage.src = qrUrl;
  }
  startRadarWatcher(ref, amt);
}

function startRadarWatcher(ref: string, amt: number) {
  if (radarText) {
    radarText.textContent = `Listening for incoming ₹${amt.toFixed(2)} payment...`;
    radarText.style.color = '#a5b4fc';
  }

  if (watcherTimer) clearInterval(watcherTimer);
  watcherTimer = setInterval(async () => {
    const check = await apiRequest<{ success: boolean; transactions: Transaction[] }>(
      `/api/transactions?search=${encodeURIComponent(ref)}&limit=1`
    );
    if (check?.transactions && check.transactions.length > 0) {
      clearInterval(watcherTimer);
      if (radarText) {
        radarText.textContent = `🎉 Payment of ₹${amt.toFixed(2)} CONFIRMED in D1!`;
        radarText.style.color = '#34d399';
      }
      showToast(`Payment received for ${ref}!`);
      refreshAll();
    }
  }, 3000);
}

// Mode Switcher (One at a time)
function setCheckoutMode(mode: 'pay' | 'qr') {
  currentCheckoutMode = mode;
  if (mode === 'pay') {
    modePayBtn.classList.add('active');
    modeQrBtn.classList.remove('active');
    payView.classList.remove('hidden');
    qrView.classList.add('hidden');
  } else {
    modeQrBtn.classList.add('active');
    modePayBtn.classList.remove('active');
    qrView.classList.remove('hidden');
    payView.classList.add('hidden');
    updateQrCode();
  }
}

modePayBtn.addEventListener('click', () => setCheckoutMode('pay'));
modeQrBtn.addEventListener('click', () => setCheckoutMode('qr'));

// Preset Amount Chips
presetChips.forEach((chip) => {
  chip.addEventListener('click', () => {
    presetChips.forEach((c) => c.classList.remove('active'));
    chip.classList.add('active');
    const amt = parseFloat(chip.getAttribute('data-amount') || '1');
    testAmountInput.value = amt.toFixed(2);
    updatePayAmountDisplay(amt);
    if (currentCheckoutMode === 'qr') {
      updateQrCode();
    }
  });
});

testAmountInput.addEventListener('input', () => {
  const val = parseFloat(testAmountInput.value) || 0;
  presetChips.forEach((chip) => {
    const chipAmt = parseFloat(chip.getAttribute('data-amount') || '0');
    if (chipAmt === val) {
      chip.classList.add('active');
    } else {
      chip.classList.remove('active');
    }
  });
  updatePayAmountDisplay(val);
  if (currentCheckoutMode === 'qr') {
    updateQrCode();
  }
});

// Parameter Inputs
testRefInput.addEventListener('input', () => {
  if (summaryOrderRef) summaryOrderRef.textContent = testRefInput.value || 'ORDER-...';
  if (currentCheckoutMode === 'qr') {
    updateQrCode();
  }
});

testVpaInput.addEventListener('change', () => {
  if (currentCheckoutMode === 'qr') {
    updateQrCode();
  }
});

testNoteInput.addEventListener('input', () => {
  if (currentCheckoutMode === 'qr') {
    updateQrCode();
  }
});

const copyRefBtn = document.getElementById('copyRefBtn') as HTMLButtonElement;
if (copyRefBtn) {
  copyRefBtn.addEventListener('click', () => {
    if (testRefInput?.value) {
      (window as any).copyToClipboard(testRefInput.value, 'Order ID');
    }
  });
}

// Deeplink Execution
function openDeeplink(url: string) {
  if (!url) return;
  showToast('Launching UPI app...');
  window.location.href = url;
}

payDirectBtn.addEventListener('click', () => {
  const { url, amt, ref } = getUpiDetails();
  startRadarWatcher(ref, amt);
  openDeeplink(url);
});

copyUpiLinkBtn.addEventListener('click', () => {
  const { url } = getUpiDetails();
  (window as any).copyToClipboard(url, 'UPI Deeplink');
});

// -------------------------------------------------------------
// Instant UTR Verifier Logic
// -------------------------------------------------------------
lookupForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  const utr = lookupInput.value.trim();
  if (!utr) return;

  lookupSubmitBtn.disabled = true;
  lookupSubmitBtn.textContent = 'Verifying...';
  lookupResultBox.classList.add('hidden');

  const res = await apiRequest<{ success: boolean; source?: string; transaction?: any; error?: string; message?: string }>(
    '/api/transactions/lookup',
    {
      method: 'POST',
      body: JSON.stringify({ utr })
    }
  );

  lookupSubmitBtn.disabled = false;
  lookupSubmitBtn.textContent = 'Verify Now';

  if (res?.success && res.transaction) {
    const tx = res.transaction;
    lookupResultBox.innerHTML = `
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:12px;">
        <span class="amount-badge">₹${Number(tx.amount).toFixed(2)}</span>
        <span class="badge badge-settled">${tx.paymentState || 'COMPLETED'}</span>
      </div>
      <div style="font-size:13px; line-height:1.6; color:var(--text-main);">
        <div>👤 <b>Payer:</b> ${tx.payerName || 'N/A'} (<code>${tx.payerVpa || 'UPI'}</code>)</div>
        <div>🏦 <b>UTR / RRN:</b> <code>${tx.utr || tx.transactionId}</code></div>
        <div>🏪 <b>Store:</b> ${tx.storeName || 'Main'} - ${tx.terminalName || 'Terminal'}</div>
        <div>🕒 <b>Timestamp:</b> ${formatTimeIST(tx.transactionDate)}</div>
        <div style="margin-top:8px; font-size:11px; color:var(--text-dim);">Source: <b>${res.source || 'Cloudflare D1'}</b></div>
      </div>
    `;
    lookupResultBox.classList.remove('hidden');
  } else {
    lookupResultBox.innerHTML = `
      <div style="color:var(--color-danger); font-size:13px;">
        ❌ <b>Not Found:</b> ${res?.message || 'No transaction record found with this UTR.'}
      </div>
    `;
    lookupResultBox.classList.remove('hidden');
  }
});

// -------------------------------------------------------------
// 1-Click Cloudflare BYOC Node Provisioning Logic (Hashed Deploy Link)
// -------------------------------------------------------------
const generateDeployForm = document.getElementById('generateDeployForm') as HTMLFormElement;
const deployMerchantNameInput = document.getElementById('deployMerchantNameInput') as HTMLInputElement;
const deployMerchantDomainInput = document.getElementById('deployMerchantDomainInput') as HTMLInputElement;
const deployLinkDisplayBox = document.getElementById('deployLinkDisplayBox') as HTMLDivElement;
const deployLinkOutput = document.getElementById('deployLinkOutput') as HTMLInputElement;
const copyDeployLinkBtn = document.getElementById('copyDeployLinkBtn') as HTMLButtonElement;
const cfDeployBtnAnchor = document.getElementById('cfDeployBtnAnchor') as HTMLAnchorElement;

if (generateDeployForm) {
  generateDeployForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = (deployMerchantNameInput?.value || '').trim();
    const domain = (deployMerchantDomainInput?.value || '').trim().toLowerCase().replace(/^https?:\/\//, '');

    if (!name) {
      showToast('Please enter merchant name', true);
      return;
    }

    const payload = {
      merchantId: name.toLowerCase().replace(/[^a-z0-9]/g, '-'),
      merchantName: name,
      domain: domain || 'localhost',
      createdAt: Date.now(),
      version: 'v2-byoc'
    };

    const token = btoa(JSON.stringify(payload));
    const currentOrigin = window.location.origin;
    const sealedSetupUrl = `${currentOrigin}/setup?m=${encodeURIComponent(name)}&token=${encodeURIComponent(token)}`;
    const cfOneClickDeployUrl = `https://deploy.workers.cloudflare.com/?url=https://github.com/theasmat/phonepay_proxy`;

    if (deployLinkOutput) deployLinkOutput.value = sealedSetupUrl;
    if (cfDeployBtnAnchor) cfDeployBtnAnchor.href = cfOneClickDeployUrl;
    if (deployLinkDisplayBox) deployLinkDisplayBox.classList.remove('hidden');

    showToast(`Sealed deployment link generated for "${name}"!`);
  });
}

if (copyDeployLinkBtn && deployLinkOutput) {
  copyDeployLinkBtn.addEventListener('click', () => {
    if (deployLinkOutput.value) {
      (window as any).copyToClipboard(deployLinkOutput.value, 'Sealed Setup Link');
    }
  });
}

// -------------------------------------------------------------
// Inline Edit Order ID Modal Logic
// -------------------------------------------------------------
const editOrderModal = document.getElementById('editOrderModal') as HTMLDivElement;
const modalTargetUtr = document.getElementById('modalTargetUtr') as HTMLInputElement;
const modalOrderId = document.getElementById('modalOrderId') as HTMLInputElement;
const modalOrderNote = document.getElementById('modalOrderNote') as HTMLInputElement;
const closeOrderModalBtn = document.getElementById('closeOrderModalBtn') as HTMLButtonElement;
const saveOrderModalBtn = document.getElementById('saveOrderModalBtn') as HTMLButtonElement;

(window as any).openOrderModal = (target: string, currentOrder: string, note: string) => {
  if (modalTargetUtr) modalTargetUtr.value = target;
  if (modalOrderId) modalOrderId.value = currentOrder || '';
  if (modalOrderNote) modalOrderNote.value = note || '';
  if (editOrderModal) editOrderModal.classList.remove('hidden');
  if (modalOrderId) modalOrderId.focus();
};

function closeOrderModal() {
  if (editOrderModal) editOrderModal.classList.add('hidden');
}

if (closeOrderModalBtn) {
  closeOrderModalBtn.addEventListener('click', closeOrderModal);
}

if (saveOrderModalBtn) {
  saveOrderModalBtn.addEventListener('click', async () => {
    const target = (modalTargetUtr?.value || '').trim();
    const orderId = (modalOrderId?.value || '').trim();
    const note = (modalOrderNote?.value || '').trim();

    if (!orderId && !note) {
      showToast('Please enter an Order ID or Note', true);
      return;
    }

    saveOrderModalBtn.disabled = true;
    showToast('Saving Order ID in SQLite D1...');

    const res = await apiRequest<{ success: boolean; message: string; transaction?: any; error?: string }>(
      '/api/v1/transactions/update-ref',
      {
        method: 'POST',
        body: JSON.stringify({
          utr: target,
          unitId: target,
          merchantTransactionId: orderId,
          transactionNote: note
        })
      }
    );

    saveOrderModalBtn.disabled = false;

    if (res?.success) {
      showToast(`Order ID saved for ${target}!`);
      closeOrderModal();
      refreshAll();
    } else {
      showToast(`Failed: ${res?.error || 'Transaction not found'}`, true);
    }
  });
}

// -------------------------------------------------------------
// Secure UPI & Order Reference Management Logic
// -------------------------------------------------------------
const upiListContainer = document.getElementById('upiListContainer') as HTMLDivElement;
const refreshUpiBtn = document.getElementById('refreshUpiBtn') as HTMLButtonElement;
const syncPhonePeDataBtn = document.getElementById('syncPhonePeDataBtn') as HTMLButtonElement;
const discoveredProfileText = document.getElementById('discoveredProfileText') as HTMLDivElement;
const discoveredTerminalText = document.getElementById('discoveredTerminalText') as HTMLDivElement;

const updateRefForm = document.getElementById('updateRefForm') as HTMLFormElement;
const updateRefTarget = document.getElementById('updateRefTarget') as HTMLInputElement;
const updateRefOrderId = document.getElementById('updateRefOrderId') as HTMLInputElement;
const updateRefNote = document.getElementById('updateRefNote') as HTMLInputElement;
const updateRefSubmitBtn = document.getElementById('updateRefSubmitBtn') as HTMLButtonElement;

async function loadUpiList() {
  if (!upiListContainer) return;
  const res = await apiRequest<{ success: boolean; total: number; upis: any[] }>('/api/v1/upi/list');

  if (!res || !res.upis) {
    upiListContainer.innerHTML = '<div class="table-placeholder">Unable to load registered UPIs.</div>';
    return;
  }

  if (res.upis.length === 0) {
    upiListContainer.innerHTML = '<div class="table-placeholder">No UPI IDs detected yet. Connect your PhonePe session to auto-sync.</div>';
    if (discoveredProfileText) discoveredProfileText.textContent = 'Session not connected';
    return;
  }

  const primaryUpi = res.upis[0];
  if (discoveredProfileText) {
    discoveredProfileText.textContent = `${primaryUpi.accountHolderName} (${primaryUpi.upiId})`;
  }
  if (discoveredTerminalText) {
    discoveredTerminalText.textContent = `${res.upis.length} Active VPA(s) locked • ${primaryUpi.bankName || 'Verified Merchant'}`;
  }

  upiListContainer.innerHTML = res.upis.map((u) => {
    const limit = Number(u.dailyLimitInr) || 100000;
    const vol = Number(u.dailyVolumeInr) || 0;
    const pct = Math.min(100, Math.round((vol / limit) * 100));
    const isExceeded = u.isLimitExceeded || vol >= limit;

    const limitBadge = isExceeded
      ? '<span class="badge badge-unsettled" style="font-size: 9px; padding: 2px 6px;">⚠️ CAP REACHED (FAILOVER ACTIVE)</span>'
      : `<span class="badge badge-settled" style="font-size: 9px; padding: 2px 6px;">ACTIVE (Priority ${u.priority || 1})</span>`;

    return `
      <div style="background: rgba(15, 23, 42, 0.6); border: 1px solid var(--border-subtle); border-radius: 10px; padding: 12px; display: flex; flex-direction: column; gap: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 6px;">
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <div style="display: flex; align-items: center; gap: 6px;">
              <span style="font-family: var(--font-mono); font-weight: 700; color: #818cf8; font-size: 13px;">${u.upiId}</span>
              ${limitBadge}
            </div>
            <span style="font-size: 12px; color: var(--text-main); font-weight: 600;">${u.accountHolderName}</span>
            ${u.bankName ? `<span style="font-size: 11px; color: var(--text-dim);">${u.bankName}</span>` : ''}
          </div>
          <div style="display: flex; gap: 6px; align-items: center;">
            <button type="button" class="btn btn-secondary btn-sm" style="padding: 4px 8px; font-size: 11px;" onclick="editUpiLimit('${u.upiId}', ${limit}, ${u.priority || 1})" title="Set Daily Cap & Priority">
              ⚙️ Limit
            </button>
            <button type="button" class="btn btn-secondary btn-sm" style="padding: 4px 8px; font-size: 11px;" onclick="copyToClipboard('${u.upiId}', 'UPI VPA')">
              Copy
            </button>
          </div>
        </div>

        <!-- Daily Volume Balancer Bar -->
        <div style="background: rgba(2, 6, 23, 0.5); border-radius: 6px; padding: 8px; border: 1px solid rgba(255, 255, 255, 0.05);">
          <div style="display: flex; justify-content: space-between; font-size: 11px; margin-bottom: 4px;">
            <span style="color: var(--text-dim);">Today's Volume:</span>
            <span style="font-weight: 700; color: ${isExceeded ? '#f87171' : '#34d399'};">
              ₹${vol.toLocaleString('en-IN')} / ₹${limit.toLocaleString('en-IN')} (${pct}%)
            </span>
          </div>
          <div style="width: 100%; height: 5px; background: rgba(255, 255, 255, 0.1); border-radius: 3px; overflow: hidden;">
            <div style="width: ${pct}%; height: 100%; background: ${isExceeded ? '#ef4444' : '#10b981'}; transition: width 0.3s ease;"></div>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

(window as any).editUpiLimit = async (upiId: string, currentLimit: number, currentPriority: number) => {
  const newLimitStr = prompt(`Set Daily Transaction Cap (₹) for ${upiId}:`, String(currentLimit));
  if (newLimitStr === null) return;
  const newLimit = Number(newLimitStr);
  if (isNaN(newLimit) || newLimit <= 0) {
    showToast('Please enter a valid positive limit', true);
    return;
  }

  const newPriorityStr = prompt(`Set Priority (1 = highest / primary):`, String(currentPriority));
  if (newPriorityStr === null) return;
  const newPriority = Number(newPriorityStr);

  showToast(`Updating limit for ${upiId}...`);
  const res = await apiRequest<{ success: boolean; message?: string; error?: string }>('/api/v1/upi/update-limit', {
    method: 'POST',
    body: JSON.stringify({
      upiId,
      dailyLimitInr: newLimit,
      priority: isNaN(newPriority) ? 1 : newPriority
    })
  });

  if (res?.success) {
    showToast(`Limit updated for ${upiId}!`);
    loadUpiList();
  } else {
    showToast(`Failed: ${res?.error || 'Unknown error'}`, true);
  }
};

if (refreshUpiBtn) {
  refreshUpiBtn.addEventListener('click', () => {
    showToast('Refreshing registered UPI list...');
    loadUpiList();
  });
}

if (syncPhonePeDataBtn) {
  syncPhonePeDataBtn.addEventListener('click', async () => {
    syncPhonePeDataBtn.disabled = true;
    showToast('Syncing outlets & VPAs from PhonePe...');
    await refreshAll();
    syncPhonePeDataBtn.disabled = false;
    showToast('PhonePe VPAs & Outlets updated!');
  });
}

if (updateRefForm) {
  updateRefForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const target = (updateRefTarget?.value || '').trim();
    const orderId = (updateRefOrderId?.value || '').trim();
    const note = (updateRefNote?.value || '').trim();

    if (!target) {
      showToast('Please provide UTR or Unit ID', true);
      return;
    }

    if (!orderId && !note) {
      showToast('Please provide New Order ID or Note', true);
      return;
    }

    updateRefSubmitBtn.disabled = true;
    showToast('Updating transaction reference...');

    const res = await apiRequest<{ success: boolean; message: string; transaction?: any; error?: string }>(
      '/api/v1/transactions/update-ref',
      {
        method: 'POST',
        body: JSON.stringify({
          utr: target,
          unitId: target,
          merchantTransactionId: orderId,
          transactionNote: note
        })
      }
    );

    updateRefSubmitBtn.disabled = false;

    if (res?.success) {
      showToast(`Order ID '${orderId}' attached successfully!`);
      updateRefForm.reset();
      refreshAll();
    } else {
      showToast(`Update failed: ${res?.message || res?.error || 'Transaction not found'}`, true);
    }
  });
}

// -------------------------------------------------------------
// Developer Secret API Keys Management Logic
// -------------------------------------------------------------
const createApiKeyForm = document.getElementById('createApiKeyForm') as HTMLFormElement;
const newKeyNameInput = document.getElementById('newKeyNameInput') as HTMLInputElement;
const createKeyBtn = document.getElementById('createKeyBtn') as HTMLButtonElement;
const newKeyDisplayBox = document.getElementById('newKeyDisplayBox') as HTMLDivElement;
const newRawKeyInput = document.getElementById('newRawKeyInput') as HTMLInputElement;
const copyRawKeyBtn = document.getElementById('copyRawKeyBtn') as HTMLButtonElement;
const apiKeysListContainer = document.getElementById('apiKeysListContainer') as HTMLDivElement;

async function loadApiKeys() {
  if (!apiKeysListContainer) return;
  const res = await apiRequest<{ success: boolean; total: number; keys: ApiKey[] }>('/api/v1/keys/list');

  if (!res || !res.keys) {
    apiKeysListContainer.innerHTML = '<div class="table-placeholder">Unable to load active API keys.</div>';
    return;
  }

  if (res.keys.length === 0) {
    apiKeysListContainer.innerHTML = '<div class="table-placeholder">No secret API keys generated yet. Generate your first developer key above.</div>';
    return;
  }

  apiKeysListContainer.innerHTML = res.keys.map((k) => {
    const isRevoked = k.status === 'REVOKED';
    const statusBadge = isRevoked
      ? '<span class="badge badge-unsettled" style="font-size: 9px; padding: 2px 6px;">REVOKED</span>'
      : '<span class="badge badge-settled" style="font-size: 9px; padding: 2px 6px;">ACTIVE</span>';
    const lastUsedText = k.lastUsedAt ? formatRelativeTime(k.lastUsedAt) : 'Never used';
    const createdText = formatRelativeTime(k.createdAt);

    return `
      <div style="background: rgba(15, 23, 42, 0.6); border: 1px solid var(--border-subtle); border-radius: 10px; padding: 12px; display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap;">
        <div style="display: flex; flex-direction: column; gap: 2px;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <span style="font-weight: 700; color: #34d399; font-size: 13px;">${k.name}</span>
            ${statusBadge}
          </div>
          <div style="font-family: var(--font-mono); font-size: 12px; color: var(--text-dim);">
            ${k.keyPrefix}••••••••••••
          </div>
          <div style="font-size: 11px; color: var(--text-dim);">
            Created ${createdText} • Last used: ${lastUsedText}
          </div>
        </div>
        <div>
          ${!isRevoked ? `
            <button type="button" class="btn btn-secondary btn-sm" style="padding: 4px 8px; font-size: 11px; color: #f87171;" onclick="revokeApiKey('${k.keyId}', '${k.name}')">
              Revoke
            </button>
          ` : ''}
        </div>
      </div>
    `;
  }).join('');
}

(window as any).revokeApiKey = async (keyId: string, name: string) => {
  if (!confirm(`Are you sure you want to revoke API key "${name}"? This action cannot be undone.`)) {
    return;
  }
  showToast(`Revoking API key "${name}"...`);
  const res = await apiRequest<{ success: boolean; message?: string; error?: string }>('/api/v1/keys/revoke', {
    method: 'POST',
    body: JSON.stringify({ keyId })
  });

  if (res?.success) {
    showToast(`Key "${name}" revoked!`);
    loadApiKeys();
  } else {
    showToast(`Failed to revoke key: ${res?.error || 'Unknown error'}`, true);
  }
};

if (createApiKeyForm) {
  createApiKeyForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const name = (newKeyNameInput?.value || '').trim();
    if (!name) {
      showToast('Please enter a key name', true);
      return;
    }

    createKeyBtn.disabled = true;
    showToast('Generating new secret API key...');

    const res = await apiRequest<{ success: boolean; apiKey?: { rawKey: string; name: string }; error?: string }>(
      '/api/v1/keys/create',
      {
        method: 'POST',
        body: JSON.stringify({ name })
      }
    );

    createKeyBtn.disabled = false;

    if (res?.success && res.apiKey) {
      showToast(`Key "${res.apiKey.name}" created!`);
      newKeyNameInput.value = '';
      if (newKeyDisplayBox && newRawKeyInput) {
        newRawKeyInput.value = res.apiKey.rawKey;
        newKeyDisplayBox.classList.remove('hidden');
      }
      loadApiKeys();
    } else {
      showToast(`Failed to generate key: ${res?.error || 'Unknown error'}`, true);
    }
  });
}

if (copyRawKeyBtn && newRawKeyInput) {
  copyRawKeyBtn.addEventListener('click', () => {
    if (newRawKeyInput.value) {
      (window as any).copyToClipboard(newRawKeyInput.value, 'Secret API Key');
    }
  });
}

// -------------------------------------------------------------
// Merchant Push Webhook Management Logic
// -------------------------------------------------------------
const saveWebhookForm = document.getElementById('saveWebhookForm') as HTMLFormElement;
const webhookUrlInput = document.getElementById('webhookUrlInput') as HTMLInputElement;
const saveWebhookBtn = document.getElementById('saveWebhookBtn') as HTMLButtonElement;
const testWebhookBtn = document.getElementById('testWebhookBtn') as HTMLButtonElement;
const webhookSecretDisplayBox = document.getElementById('webhookSecretDisplayBox') as HTMLDivElement;
const webhookSecretInput = document.getElementById('webhookSecretInput') as HTMLInputElement;
const copyWebhookSecretBtn = document.getElementById('copyWebhookSecretBtn') as HTMLButtonElement;
const refreshDeliveriesBtn = document.getElementById('refreshDeliveriesBtn') as HTMLButtonElement;
const webhookDeliveriesContainer = document.getElementById('webhookDeliveriesContainer') as HTMLDivElement;

async function loadWebhookSettings() {
  if (!webhookUrlInput) return;
  const res = await apiRequest<{
    success: boolean;
    isConfigured: boolean;
    webhook?: { url: string; secret: string; isActive: boolean };
    error?: string;
  }>('/api/v1/webhooks/get');

  if (res?.success && res.isConfigured && res.webhook) {
    webhookUrlInput.value = res.webhook.url;
    if (webhookSecretInput && webhookSecretDisplayBox) {
      webhookSecretInput.value = res.webhook.secret;
      webhookSecretDisplayBox.classList.remove('hidden');
    }
  }
}

async function loadWebhookDeliveries() {
  if (!webhookDeliveriesContainer) return;
  const res = await apiRequest<{
    success: boolean;
    deliveries: Array<{
      deliveryId: string;
      orderId: string;
      event: string;
      responseStatus: number;
      responseBody: string;
      attemptCount: number;
      status: 'SUCCESS' | 'FAILED';
      createdAt: number;
    }>;
  }>('/api/v1/webhooks/deliveries');

  if (!res || !res.deliveries) {
    webhookDeliveriesContainer.innerHTML = '<div class="table-placeholder">Unable to load webhook delivery logs.</div>';
    return;
  }

  if (res.deliveries.length === 0) {
    webhookDeliveriesContainer.innerHTML = '<div class="table-placeholder">No webhook events dispatched yet. Click "Send Test Ping" to test.</div>';
    return;
  }

  webhookDeliveriesContainer.innerHTML = res.deliveries.map((d) => {
    const isSuccess = d.status === 'SUCCESS';
    const statusBadge = isSuccess
      ? `<span class="badge badge-settled" style="font-size: 9px; padding: 2px 6px;">HTTP ${d.responseStatus || 200} SUCCESS</span>`
      : `<span class="badge badge-unsettled" style="font-size: 9px; padding: 2px 6px;">${d.responseStatus ? `HTTP ${d.responseStatus}` : 'FAILED'} (Retry ${d.attemptCount}/4)</span>`;
    const timeText = formatRelativeTime(d.createdAt);

    return `
      <div style="background: rgba(15, 23, 42, 0.6); border: 1px solid var(--border-subtle); border-radius: 8px; padding: 10px; display: flex; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap;">
        <div style="display: flex; flex-direction: column; gap: 2px;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <span style="font-weight: 700; color: #818cf8; font-size: 12px;">${d.event}</span>
            ${statusBadge}
          </div>
          <div style="font-family: var(--font-mono); font-size: 11px; color: var(--text-dim);">
            Order: <span style="color: var(--text-main); font-weight: 600;">${d.orderId}</span> • ${timeText}
          </div>
          ${d.responseBody ? `<div style="font-size: 10px; color: var(--text-dim); max-width: 480px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${d.responseBody}</div>` : ''}
        </div>
        <div style="font-family: var(--font-mono); font-size: 10px; color: var(--text-dim);">
          ${d.deliveryId}
        </div>
      </div>
    `;
  }).join('');
}

if (saveWebhookForm) {
  saveWebhookForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const url = (webhookUrlInput?.value || '').trim();
    if (!url) {
      showToast('Please enter a valid webhook URL', true);
      return;
    }

    saveWebhookBtn.disabled = true;
    showToast('Saving webhook configuration...');

    const res = await apiRequest<{
      success: boolean;
      message: string;
      webhook?: { url: string; secret: string };
      error?: string;
    }>('/api/v1/webhooks/save', {
      method: 'POST',
      body: JSON.stringify({ url })
    });

    saveWebhookBtn.disabled = false;

    if (res?.success && res.webhook) {
      showToast('Webhook endpoint saved successfully!');
      if (webhookSecretInput && webhookSecretDisplayBox) {
        webhookSecretInput.value = res.webhook.secret;
        webhookSecretDisplayBox.classList.remove('hidden');
      }
      loadWebhookDeliveries();
    } else {
      showToast(`Failed to save webhook: ${res?.error || 'Unknown error'}`, true);
    }
  });
}

if (testWebhookBtn) {
  testWebhookBtn.addEventListener('click', async () => {
    testWebhookBtn.disabled = true;
    showToast('Dispatching test webhook ping...');

    const res = await apiRequest<{
      success: boolean;
      message: string;
      dispatched: number;
      successful: number;
      error?: string;
    }>('/api/v1/webhooks/test', {
      method: 'POST'
    });

    testWebhookBtn.disabled = false;

    if (res?.success) {
      showToast(res.message);
      loadWebhookDeliveries();
    } else {
      showToast(res?.message || res?.error || 'Test webhook failed', true);
      loadWebhookDeliveries();
    }
  });
}

if (copyWebhookSecretBtn && webhookSecretInput) {
  copyWebhookSecretBtn.addEventListener('click', () => {
    if (webhookSecretInput.value) {
      (window as any).copyToClipboard(webhookSecretInput.value, 'Webhook Secret');
    }
  });
}

if (refreshDeliveriesBtn) {
  refreshDeliveriesBtn.addEventListener('click', () => {
    showToast('Refreshing delivery logs...');
    loadWebhookDeliveries();
  });
}

// Bootstrap
refreshAll();
setupAutoRefresh();
